export default __webpack_public_path__ + "static/media/ic-turn-left.73749197.svg";